<a [id]="id" class="hint-button" (click)="togglePopup()" [@buttonHint]="showPopup">
  <span *ngIf="showPopup" class="content" #contentElement>{{ content }}</span>
  <span *ngIf="showPopup" class="arrow" #arrowElement></span>
  ?
</a>
